var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import { useState, useEffect } from 'react';

var getVisibility = function getVisibility() {
  if (typeof document === 'undefined') return;
  return document.visibilityState;
};

function useDocumentVisibility() {
  var _a = __read(useState(getVisibility()), 2),
      documentVisibility = _a[0],
      setDocumentVisibility = _a[1];

  useEffect(function () {
    var handleVisibilityChange = function handleVisibilityChange() {
      setDocumentVisibility(getVisibility());
    };

    window.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return documentVisibility;
}

export default useDocumentVisibility;